<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>

      <AutoComplete
        :value="searchSchool"
        v-model="searchSchool"
        key-value="id"
        key-name="fullname"
        enable-chips
        enable-clearable
        enable-autofocus
        :items="schools"
        :label="$t('fields.school')"
        @search="searchSchools"
        @input="fetchSchoolsIfExist"
        @clear="deleteSelectedSchools"
        :delay="900"
      >
      </AutoComplete>

      <ValidationObserver
        ref="form"
        tag="form"
        @submit.prevent="save"
      >

        <ValidationProvider
            rules="required"
            vid="school_code"
            :name="$t('fields.school_code').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-radio-group
            v-model="form.schoolCodeId"
            :error-messages="errors"
          >
            <v-radio
              v-for="code in codes"
              :key="code.id"
              :label="`${code.name}`"
              :value="code.id"
            ></v-radio>
          </v-radio-group>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="adoption_year"
            :name="$t('fields.adoption_year').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-text-field
            v-model=" form.adoption_year"
            :counter="13"
            :label="$t('fields.adoption_year')"
            :error-messages="errors"
          ></v-text-field>
        </ValidationProvider>

        <ValidationProvider
            vid="isbn"
            :name="$t('fields.isbn').toLowerCase()"
        >
          <Search
            v-model="filters.search"
            :label="$t('SEARCH')"
            prepend-icon="search"
            :delay="500"
          />
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="isbn"
            :name="$t('fields.isbn').toLowerCase()"
            v-slot="{ errors }"
        >
              <v-data-table
                v-model="bookSelected"
                :single-select="true"
                :headers="headers"
                :items="books"
                show-select
                item-key="isbn"
                :server-items-length="totalItems"
                :no-data-text="$t('NO_DATA')"
                :no-results-text="$t('NO_DATA')"
                hide-default-footer
                :options.sync="pagination"
                :loading="loading"
                class="elevation-1"
              >
              </v-data-table>

              <div v-if="!bookSelected.length"
                class="v-messages theme--light error--text mt-3"
                role="alert"
              >
                <div class="v-messages__wrapper">
                  <div class="v-messages__message">Libro obbrigatorio</div>
                </div>
              </div>

              <div class="text-xs-center pt-2">
                  <Paginator
                    :total-items="totalItems"
                    :page.sync="pagination.page"
                    :items-per-page.sync="pagination.itemsPerPage"
                    @change="fetchBooks"
                  />
              </div>
        </ValidationProvider>

        <ValidationProvider
            rules="required"
            vid="class"
            :name="$t('fields.class').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-select
            v-model=" form.class"
            :label="$t('fields.class')"
            :error-messages="errors"
            :items="[1, 2, 3, 4, 5]"
          >
          </v-select>
        </ValidationProvider>

        <ValidationProvider
            :rules="isSectionRequired"
            vid="section"
            :name="$t('fields.section').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-container fluid>
            <v-row>
            <v-col
              cols="1"
              v-for="item in classes" :key="item"
            >
            <v-checkbox
              v-model="form.section"
              :label="item"
              :error-messages="errors"
              :value="item"
              multiple

            ></v-checkbox>
            </v-col>
            </v-row>
          </v-container>
          </ValidationProvider>

          <ValidationProvider
            :rules="isOtherSectionRequired"
            vid="other:section"
            :name="$t('fields.section').toLowerCase()"
            v-slot="{ errors }"
          >
            <v-text-field
              v-model=" form.other_section"
              :label="$t('fields.other_section')"
              :error-messages="errors"
              hint="Inserisci le sezioni separate da ,"
            ></v-text-field>
          </ValidationProvider>


        <ValidationProvider
            vid="is_new"
            :name="$t('fields.is_new').toLowerCase()"
            v-slot="{ errors }"
        >
          <v-checkbox
            v-model="form.is_new"
            :label="$t('fields.is_new')"
            :error-messages="errors"
          ></v-checkbox>
        </ValidationProvider>

        <ValidationProvider
            vid="is_suggested"
            :name="$t('fields.is_suggested').toLowerCase()"
            :error-messages="errors"
            v-slot="{ errors }"
        >
          <v-checkbox
            v-model="form.is_suggested"
            :label="$t('fields.is_suggested')"
            :error-messages="errors"
          ></v-checkbox>
        </ValidationProvider>

    </ValidationObserver>
    </v-card-text>
    <v-card-actions>
      <v-btn @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
      <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { schoolsService } from '../../../utils/services/schools.service';
  import { schoolsCodesService } from '../../../utils/services/schoolsCodes.service';
  import { booksService } from '../../../utils/services/books.service';

  import AutoComplete from '../../shared/Inputs/AutoComplete.vue';
  import Search from '../../shared/Inputs/Search.vue';
  import Paginator from '../../shared/Paginator';

  export default {
    name: 'BookModal',
    components: {
      AutoComplete,
      Search,
      Paginator,
    },
    data() {
      return {
        headers: [
          { text: '', value: '' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume', sortable: true },
          { text: this.$t('fields.year'), value: 'pubblication_year', sortable: true },
          { text: this.$t('fields.editor'), value: 'editor', sortable: true },
        ],
        books: [],
        bookSelected: [],
        classes: [
          'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I',
          'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T',
          'V', 'W', 'Z',
        ],
        stored: null,
        codes: [],
        schools: [],
        searchSchool: null,
        book: {},
        form: {},
        loading: false,
        errors: {},
        filters: {
          searchSchools: null,
          schoolId: 0,
          search: null,
        },
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [true],
          sortBy: ['title'],
        },
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),

      isOtherSectionRequired() {
        return (this.form.section) ? null : 'required';
      },

      isSectionRequired() {
        return (this.form.other_section) ? null : 'required';
      },

      requestFilters() {
        const filters = {
          search: this.filters.search,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),

      async fetchBooks(forcePage) {
        this.loadingBook = true;
        const { page, itemsPerPage } = this.pagination;
        return booksService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.books = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loadingBook = false;
          });
      },

      async save() {
        const isValid = await this.$refs.form.validate();
        if (isValid && this.bookSelected.length) {
            const form = {
                schoolCodeId: this.form.schoolCodeId,
                adoption_year: this.form.adoption_year,
                class: this.form.class,
                section: this.form.section,
                other_section: this.form.other_section,
                is_new: this.form.is_new,
                is_suggested: this.form.is_suggested,
                isbn: this.bookSelected[0].isbn,
            };

            if (this.options.onSave) {
              this.loadingModal(true);
              this.options.onSave(
                form,
                this.$refs.form,
              )
              .then(() => {
                  this.loadingModal(false);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },

      deleteSelectedSchools() {
        this.codes = [];
      },

      fetchCodes(schoolId) {
        return schoolsCodesService.index(schoolId)
        .then(response => {
            this.codes = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        });
      },

      async searchSchools(val) {
        this.filters.searchSchools = val;
        await this.fetchSchools();
      },

      fetchSchools() {
        this.loading = true;
        return schoolsService.index({
          filters: {
            search: this.filters.searchSchools,
          },
        })
        .then(response => {
            this.schools = response.data.data;
        })
        .catch(error => {
            this.handleError(error, this.errors);
        })
        .finally(() => {
            this.loading = false;
        });
      },

      async fetchSchoolsIfExist(id) {
        if (id > 0) {
          this.filters.schoolId = id;
          await this.fetchCodes(id);
        } else {
          this.filters.schoolId = 0;
        }
      },

    },
    async created() {
      this.fetchBooks(1);
    },

    watch: {

      filters: {
        deep: true,
        handler() {
          this.fetchBooks(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchBooks(1);
          }
        },
      },

    },


  };
</script>
